import { IMG } from "./site";

export const BLOG_POSTS = [
  {
    slug: "que-es-el-detailing",
    img: IMG.side,
    minutes: 4,
    services: ["detailing-integral", "limpieza-interior", "limpieza-exterior"],
    es: { title: "Qué es el detailing de coches", excerpt: "Detailing no es un lavado caro: es evaluar, corregir y proteger. Te contamos qué es de verdad y para quién tiene sentido." },
    ca: { title: "Què és el detailing de cotxes", excerpt: "El detailing no és un rentat car: és avaluar, corregir i protegir. T'expliquem què és de debò i per a qui té sentit." },
  },
  {
    slug: "diferencias-lavado-detailing",
    img: IMG.heroDark,
    minutes: 4,
    services: ["limpieza-exterior", "detailing-integral"],
    es: { title: "Diferencias entre lavado y detailing", excerpt: "Diez euros de túnel de lavado contra horas de trabajo a mano. Esto es lo que separa de verdad ambos mundos." },
    ca: { title: "Diferències entre rentat i detailing", excerpt: "Deu euros de túnel de rentat contra hores de feina a mà. Això és el que separa de veritat tots dos móns." },
  },
  {
    slug: "como-limpiar-interior-coche",
    img: IMG.interior,
    minutes: 5,
    services: ["limpieza-interior", "limpieza-interior-a-domicilio"],
    es: { title: "Cómo limpiar el interior del coche como un profesional", excerpt: "Aspirado profundo, tapicería, plásticos y los detalles que marcan la diferencia. El método paso a paso." },
    ca: { title: "Com netejar l'interior del cotxe com un professional", excerpt: "Aspirat profund, tapisseria, plàstics i els detalls que marquen la diferència. El mètode pas a pas." },
  },
  {
    slug: "que-es-pulido-one-step",
    img: IMG.polishing,
    minutes: 4,
    services: ["pulido-de-coches", "proteccion-fusso-coat"],
    es: { title: "Qué es el pulido One-Step", excerpt: "Un solo paso que combina corte y acabado: qué corrige, qué no corrige y cuándo es suficiente para tu coche." },
    ca: { title: "Què és el polit One-Step", excerpt: "Una sola passa que combina tall i acabat: què corregeix, què no corregeix i quan és suficient per al teu cotxe." },
  },
  {
    slug: "cuando-pulido-dos-pasos",
    img: IMG.correction,
    minutes: 4,
    services: ["pulido-de-coches", "correccion-de-pintura"],
    es: { title: "Cuándo realizar un pulido de dos pasos", excerpt: "Corte y refinado por separado: cuándo tu pintura necesita corrección seria y no le basta un One-Step." },
    ca: { title: "Quan fer un polit de dues passes", excerpt: "Tall i refinat per separat: quan la teva pintura necessita correcció seriosa i no li n'hi ha prou amb un One-Step." },
  },
  {
    slug: "que-es-tratamiento-ceramico",
    img: IMG.ceramic,
    minutes: 5,
    services: ["tratamiento-ceramico", "correccion-de-pintura"],
    es: { title: "Qué es un tratamiento cerámico", excerpt: "Qué hace y qué no hace el cerámico, sin humo: hidrofobia, resistencia, brillo y sus límites reales." },
    ca: { title: "Què és un tractament ceràmic", excerpt: "Què fa i què no fa el ceràmic, sense fum: hidrofòbia, resistència, brillantor i els seus límits reals." },
  },
  {
    slug: "fusso-coat-vs-ceramica",
    img: IMG.ceramic,
    minutes: 4,
    services: ["proteccion-fusso-coat", "tratamiento-ceramico"],
    es: { title: "Fusso Coat frente a tratamiento cerámico", excerpt: "Las dos protecciones que aplicamos, comparadas sin rodeos: duración, resistencia, precio y para quién es cada una." },
    ca: { title: "Fusso Coat enfront de tractament ceràmic", excerpt: "Les dues proteccions que apliquem, comparades sense embuts: durada, resistència, preu i per a qui és cadascuna." },
  },
  {
    slug: "restaurar-faros-amarillentos",
    img: IMG.hero,
    minutes: 4,
    services: ["restauracion-de-faros", "servicios-extra"],
    es: { title: "Cómo restaurar faros amarillentos", excerpt: "Por qué se degradan los faros, por qué los remedios caseros no duran y cómo se restauran de verdad." },
    ca: { title: "Com restaurar fars groguencs", excerpt: "Per què es degraden els fars, per què els remeis casolans no duren i com es restauren de debò." },
  },
  {
    slug: "cuidar-cuero-coche",
    img: IMG.leather,
    minutes: 4,
    services: ["servicios-extra", "limpieza-interior"],
    es: { title: "Cómo cuidar el cuero del coche", excerpt: "Limpieza e hidratación del cuero: la rutina que separa unos asientos con carácter de unos agrietados." },
    ca: { title: "Com cuidar el cuir del cotxe", excerpt: "Neteja i hidratació del cuir: la rutina que separa uns seients amb caràcter d'uns d'esquerdat." },
  },
  {
    slug: "mantener-pintura-brillante",
    img: IMG.side,
    minutes: 5,
    services: ["limpieza-exterior", "tratamiento-ceramico"],
    es: { title: "Cómo mantener la pintura brillante todo el año", excerpt: "Cinco claves para que el brillo no se apague: lavado correcto, protección y hábitos que funcionan." },
    ca: { title: "Com mantenir la pintura brillant tot l'any", excerpt: "Cinc claus perquè la brillantor no s'apagui: rentat correcte, protecció i hàbits que funcionen." },
  },
  {
    slug: "para-que-sirve-antilluvia",
    img: IMG.heroDark,
    minutes: 3,
    services: ["servicios-extra"],
    es: { title: "Para qué sirve el tratamiento antilluvia", excerpt: "Gotas que vuelan del parabrisas a partir de 70 km/h: así funciona el hidrofóbico de cristales y por qué la aplicación importa." },
    ca: { title: "Per a què serveix el tractament antipluja", excerpt: "Gotes que volen del parabrisa a partir de 70 km/h: així funciona l'hidrofòbic de vidres i per què l'aplicació importa." },
  },
  {
    slug: "mantener-vehiculo-limpio",
    img: IMG.interiorWork,
    minutes: 4,
    services: ["limpieza-interior", "limpieza-exterior"],
    es: { title: "Cómo mantener el vehículo limpio entre tratamientos", excerpt: "Hábitos de cinco minutos que alargan meses el resultado de una limpieza profesional." },
    ca: { title: "Com mantenir el vehicle net entre tractaments", excerpt: "Hàbits de cinc minuts que allarguen mesos el resultat d'una neteja professional." },
  },
];

export function getPost(slug) {
  return BLOG_POSTS.find((p) => p.slug === slug);
}

export function postUrl(slug, lang) {
  return lang === "ca" ? `/ca/blog/${slug}` : `/blog/${slug}`;
}
